import { render, staticRenderFns } from "./ControlsPlayIcon.vue?vue&type=template&id=c71a18aa&scoped=true&"
import script from "./ControlsPlayIcon.vue?vue&type=script&lang=js&"
export * from "./ControlsPlayIcon.vue?vue&type=script&lang=js&"
import style0 from "./ControlsPlayIcon.vue?vue&type=style&index=0&id=c71a18aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71a18aa",
  null
  
)

export default component.exports